module.exports = __webpack_public_path__ + "static/media/PayPalIntegration.e1bd9b81.pdf";